import { Box, Button, Heading, Image, Text, TextButton } from '@wix/design-system'
import { ChoiceQuestionContentComponent, useContent, useNext } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import { sorryDataHooks as dataHooks } from './Sorry.dataHooks'
import s from './Sorry.scss'

export type SorryContent = {
  question: ChoiceQuestionContentComponent<{ title: string; subtitle: string; img: string }, { button: string }>
}

export const Sorry: FC = () => {
  const { content } = useContent<SorryContent>()
  const { img, subtitle, title } = content.question.content
  const [primaryButton, secondaryButton] = content.question.options

  const { questionKey } = content.question
  const next = useNext()

  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleClick = (optionKey: string) => {
    void pageLogger.answer({ answer: optionKey })
    next({
      [questionKey]: {
        values: [optionKey],
      },
    })
  }

  return (
    <Box width="100%">
      <Box height="42px" verticalAlign="middle" gap="18px" position="absolute" left="36px" top="36px">
        <WixLogo />
      </Box>
      <Box direction="vertical" margin="20vh auto 0 auto" textAlign="center" align="center">
        <Image transparent width="120px" height="120px" src={img} dataHook={dataHooks.image()} />
        <Box marginTop="SP2">
          <Heading className={s.title} dataHook={dataHooks.title()}>
            {title}
          </Heading>
        </Box>
        <Box maxWidth="370px" marginTop="14px">
          <Text dataHook={dataHooks.subtitle()}>{subtitle}</Text>
        </Box>
        <Box marginTop="26px" gap="12px" direction="vertical" align="center">
          {primaryButton && (
            <Button
              size="large"
              onClick={() => handleClick(primaryButton.optionKey)}
              dataHook={dataHooks.primaryButton()}
            >
              {primaryButton.button}
            </Button>
          )}
          {secondaryButton && (
            <TextButton
              underline="always"
              onClick={() => handleClick(secondaryButton.optionKey)}
              dataHook={dataHooks.secondaryButton()}
            >
              {secondaryButton.button}
            </TextButton>
          )}
        </Box>
      </Box>
    </Box>
  )
}
